import { render, staticRenderFns } from "./ProjectQuota.vue?vue&type=template&id=1d28ae94&scoped=true&"
import script from "./ProjectQuota.vue?vue&type=script&lang=ts&"
export * from "./ProjectQuota.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectQuota.vue?vue&type=style&index=0&id=1d28ae94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28ae94",
  null
  
)

export default component.exports